/**
 * DTOs de miembros de organización (`/orgs/:orgId/members`). Ver docs/FASE-0.md §5 "Miembros".
 */
import { z } from "zod";
import { PATTERNS } from "../constants.js";
import { ModuleRoleSchema } from "../manifest.js";
/**
 * Invita a un usuario a la organización. `roles` mapea código de módulo → códigos de rol
 * (validados contra `module_roles` al procesar la invitación, no aquí).
 */
export const InviteMemberInputSchema = z.object({
    email: z.email(),
    fullName: z.string().min(1).max(200).optional(),
    roles: z.record(z.string().regex(PATTERNS.MODULE_CODE), z.array(z.string().regex(PATTERNS.KEY)).min(1)),
});
/** Actualiza roles por módulo y/o el estado de la membresía. */
export const UpdateMemberInputSchema = z.object({
    roles: z
        .record(z.string().regex(PATTERNS.MODULE_CODE), z.array(z.string().regex(PATTERNS.KEY)))
        .optional(),
    status: z.enum(["active", "suspended"]).optional(),
});
/**
 * Un módulo cuyos roles se pueden asignar en esta organización, con su catálogo de roles
 * (`GET /orgs/:orgId/assignable-roles`).
 */
export const AssignableModuleRolesSchema = z.object({
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
    moduleName: z.string(),
    /**
     * `false` para el módulo del portal, que no se factura y por eso no aparece en las
     * suscripciones de la organización aunque sus roles sí sean asignables.
     */
    subscribed: z.boolean(),
    roles: z.array(ModuleRoleSchema),
});
/**
 * Respuesta de `GET /orgs/:orgId/assignable-roles`: qué roles puede repartir quien administra
 * esta organización. Existe para que la pantalla de invitación no tenga que traerse el catálogo
 * entero de módulos y cruzarlo con las suscripciones: la regla de qué es asignable vive en el
 * núcleo, que es quien después la valida (ADR-007).
 */
export const AssignableRolesResponseSchema = z.object({
    items: z.array(AssignableModuleRolesSchema),
});
//# sourceMappingURL=members.js.map